import axiosAPI from "axios";

const axios = axiosAPI.create({
    baseURL: process.env.REACT_APP_API_URL,
});

// ---- Helper: Refresh Token API ----
const refreshAccessToken = async () => {
    const loginData = localStorage.getItem("BIPARD-registration") ? JSON.parse(localStorage.getItem("BIPARD-registration")) : null;
    const refreshToken = loginData ? loginData.refreshToken : null;
    
    return axiosAPI.post(`${process.env.REACT_APP_API_URL}/admin/auth/refresh-token`, {
        refreshToken: refreshToken,
    });
};

// ---- Response Interceptor ----
let isRefreshing = false;
let pendingRequests = [];

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        // If unauthorized (401) and not yet retried
        if (error.response?.status === 401 && originalRequest?.url !== "/admin/auth") {
            originalRequest._retry = true;

            if (isRefreshing) {
                // queue requests while refresh is in progress
                return new Promise((resolve, reject) => {
                    pendingRequests.push({ resolve, reject });
                })
                    .then((token) => {
                        originalRequest.headers["x-access-token"] = token;
                        return axios(originalRequest);
                    })
                    .catch((err) => Promise.reject(err));
            }

            isRefreshing = true;

            try {
                const { data } = await refreshAccessToken();

                const newToken = data?.data?.token;
                const refreshToken = data?.data?.refreshToken;
                let loginData = localStorage.getItem("BIPARD-registration") ? JSON.parse(localStorage.getItem("BIPARD-registration")) : null;
                loginData.refreshToken = refreshToken;
                loginData.token = newToken;
                localStorage.setItem("BIPARD-registration", JSON.stringify(loginData));

                // Process all pending requests now that we have a new token
                pendingRequests.forEach((p) => p.resolve(newToken));
                pendingRequests = [];

                // Retry original request
                originalRequest.headers["x-access-token"] = newToken;
                return axios(originalRequest);
            } catch (refreshError) {
                // Refresh failed → logout user
                console.log(refreshError);
                
                pendingRequests.forEach((p) => p.reject(refreshError));
                pendingRequests = [];

                localStorage.clear();
                window.location.href = "/login";
                return Promise.reject(refreshError);
            } finally {
                isRefreshing = false;
            }
        }

        return Promise.reject(error);
    }
);

export { axios };
